export default __webpack_public_path__ + "static/media/back.4050de52.png";